var n = {
  lastWeek: function(t) {
    var e = t.getUTCDay(), o = e === 0 || e === 6 ? "último" : "última";
    return "'" + o + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, s = function(t, e, o, f) {
  var a = n[t];
  return typeof a == "function" ? a(e) : a;
};
const i = s;
export {
  i as default
};
